import { Container, Grid } from "@mui/material";
import React from "react";

const ThreeTogether = () => {
    return(
        <div className="OS---ThreeTogether py-5">
            <Container>
                <Grid
                    container
                    justifyContent="center"
                    alignContent="center"
                    className="py-md-5"
                >
                    <Grid
                        xs={12}
                    >
                        <h2 className="OS---sectionHeading">3, 3 Together</h2>
                    </Grid>
                    <Grid
                        xs={12}
                        sm={8}
                        lg={6}
                    >
                        <p className="text-center">OhmniShiba rewards stakers with compounding interest, increasing their OHMS holdings over time.</p>
                    </Grid>
                </Grid>
            </Container>  
        </div>
    );
}

export default ThreeTogether;